// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { localStorageName } from "../core/constants";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  // Load from localStorage on refresh
  useEffect(() => {
    const savedUser = localStorage.getItem(localStorageName);
    if (savedUser) {
      setUser(JSON.parse(savedUser));
      console.log("savedUser ",savedUser)
    }
  }, []);

  const login = (username, token) => {
    const userData = { username, token };
    localStorage.setItem(localStorageName, JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem(localStorageName);
    setUser(null);
    
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
